import find from 'lodash/find';
import head from 'lodash/head';

export class CampaignModel {
  constructor(item, domain) {
    this.name = item.name;
    this.campaign_id = item.cid;
    this.price = item.product.price;
    this.back_image = item.product.back_url;
    this.front_image = item.product.front_url;
    this.default_side = item.product.default_side;
    this.msrp = item.product.msrp;

    let splitUri = item.url.replace(domain, '').split('/'),
      slug = splitUri[splitUri.length - 1];

    this.uri = slug;
  }
};

export const RecentlyViewedModel = class {
  constructor(campaign) {
    let defaultProduct = this.defaultProduct(campaign);

    if (defaultProduct) {
      let defaultColor = this.defaultColor(defaultProduct.colors);

      this.selling_price = defaultProduct.selling_price;

      this.preview_image = defaultColor[`${defaultProduct.default_side.toLowerCase()}_url`];

      this.msrp = defaultProduct.msrp;
    } else {
      this.selling_price = 0;

      this.preview_image = '';

      this.msrp = 0;
    }

    this.campaign_id = campaign.analytics_cid;

    this.uri = campaign.url;

    this.name = campaign.name;
  }

  defaultProduct(campaign) {
    let product = find(campaign.products, product => {
      return find(product.colors, color => color.is_default);
    });

    if (!product) {
      product = head(campaign.products);
    }

    return product;
  }

  defaultColor(colors) {
    let color = find(colors, color => color.is_default);

    if (!color) {
      color = head(colors);
    }

    return color;
  }
};